export default "__VITE_ASSET__CCCaj$Og__"